import type { ReactNode } from "react";

type CardFieldProps = {
  label: string
  value?: string | number | null
  children?: ReactNode
  className?: string
}

export const CardField = ({ label, value, children, className = "" }: CardFieldProps) => (
  <div className={`flex flex-col ${className}`}>
    <span className="text-[12px] text-gray-400 font-medium mb-1">{label}</span>
    <div className="text-[15px] font-semibold text-white flex items-center gap-2">
      {children ? children : value || "--"}
    </div>
  </div>
)

